/* MBA-995 Starter Pack landing pages.
   - Every [data-pe-lp-cta] empties the cart, adds 1 Starter Pack, then lands on
     /discount/<code>?redirect=/checkout. No window.fetch for cart work: Moon Bundles patches it
     sitewide, so the cart clear goes through an isolated iframe's own fetch and the add uses XHR,
     with the native /cart/add form POST as the fallback.
   - Sticky bar (<=989px) shows once the hero CTA is scrolled past and hides while another CTA is on screen.
   - Optional video modal for the "Scott in the lab" still.
   - Page D email form subscribes to the welcome-popup Klaviyo list. */
(function () {
  'use strict';

  var cleanFetch = null;
  function getCleanFetch() {
    if (cleanFetch) return cleanFetch;
    try {
      var frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      document.body.appendChild(frame);
      var f = frame.contentWindow && frame.contentWindow.fetch;
      if (typeof f === 'function') cleanFetch = f.bind(frame.contentWindow);
    } catch (e) { /* fall through to null */ }
    return cleanFetch;
  }

  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function (resolve) { setTimeout(resolve, ms); })]);
  }

  /* ---------------- CTA → cart → checkout ---------------- */
  var busy = false;
  function goToCheckout(trigger) {
    var form = document.getElementById('pe-lp-cart-form');
    if (!form || busy) return;
    busy = true;
    document.querySelectorAll('[data-pe-lp-cta]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });

    var f = getCleanFetch();
    var clear = f
      ? f(form.getAttribute('data-clear-url') || '/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: '{}'
        }).catch(function () {})
      : Promise.resolve();

    // Add with a main-window XHR so Shopify emits its standard product_added_to_cart event
    // (Meta, Google, Klaviyo, Triple Whale pixels listen to it), then go to the discount + checkout URL.
    // If the XHR fails, fall back to the native form POST, which lands on the same URL.
    var nativeSubmit = function () { HTMLFormElement.prototype.submit.call(form); };
    withTimeout(clear, 2500).then(function () {
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var next = form.querySelector('input[name="return_to"]').value;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', form.getAttribute('action').replace(/\/?$/, '') + '.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.timeout = 6000;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          setTimeout(function () { window.location.assign(next); }, 700);
        } else {
          nativeSubmit();
        }
      };
      xhr.onerror = xhr.ontimeout = nativeSubmit;
      xhr.send(JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) || 1 }] }));
    });

    // If the page is restored from bfcache after Back, let the buttons work again.
    window.addEventListener('pageshow', function () {
      busy = false;
      document.querySelectorAll('[data-pe-lp-cta]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    }, { once: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pe-lp-cta]');
    if (!btn) return;
    e.preventDefault();
    goToCheckout(btn);
  });

  /* ---------------- anchors ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#pe-lp-"]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var focusable = target.querySelector('input[type="email"]');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 450);
  });

  /* ---------------- sticky bar ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-pe-lp-sticky]');
    var heroCta = document.querySelector('[data-pe-lp-hero-cta]');
    if (!bar || !heroCta || !('IntersectionObserver' in window)) return;

    var others = Array.prototype.slice.call(document.querySelectorAll('[data-pe-lp-cta]:not([data-pe-lp-sticky-cta]), [data-pe-lp-hide-sticky]'))
      .filter(function (el) { return el !== heroCta; });
    var heroPassed = false;
    var visibleOthers = new Set();

    function update() {
      var show = heroPassed && visibleOthers.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button, a').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('pe-lp-has-sticky', show);
    }

    // Position check on scroll, not an observer: an observer never fires when the page jumps
    // straight past the hero CTA (scroll restore on reload, anchor links), so the bar would never show.
    var ticking = false;
    function checkHero() {
      ticking = false;
      var passed = heroCta.getBoundingClientRect().bottom < 0;
      if (passed !== heroPassed) { heroPassed = passed; update(); }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkHero); }
    }, { passive: true });
    window.addEventListener('resize', checkHero);
    checkHero();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visibleOthers.add(en.target); else visibleOthers.delete(en.target);
      });
      update();
    }, { rootMargin: '0px 0px -40px 0px' });
    others.forEach(function (el) { io.observe(el); });
    update();
  }

  /* ---------------- video ---------------- */
  function initVideo() {
    var modal = null;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-pe-lp-video]');
      if (!trigger) return;
      var src = trigger.getAttribute('data-video-src');
      if (!src) return;
      e.preventDefault();
      var isFile = /\.(mp4|webm|mov|m3u8)(\?|$)/i.test(src);
      if (!isFile) { window.open(src, '_blank', 'noopener'); return; }
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'pe-lp-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', trigger.getAttribute('aria-label') || 'Video');
        modal.innerHTML = '<button type="button" class="pe-lp-modal__close" aria-label="Close">&times;</button><video controls playsinline></video>';
        document.body.appendChild(modal);
        modal.addEventListener('click', function (ev) {
          if (ev.target === modal || ev.target.classList.contains('pe-lp-modal__close')) close();
        });
        document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });
      }
      var video = modal.querySelector('video');
      video.src = src;
      modal.classList.add('is-open');
      modal.querySelector('.pe-lp-modal__close').focus();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      function close() {
        video.pause();
        modal.classList.remove('is-open');
        trigger.focus();
      }
    });
  }

  /* ---------------- Klaviyo opt-in (page D) ---------------- */
  function initOptin() {
    document.querySelectorAll('[data-pe-lp-optin]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var input = wrap.querySelector('input[type="email"]');
      var btn = wrap.querySelector('button[type="submit"]');
      var msg = wrap.querySelector('[data-pe-lp-optin-msg]');
      if (!form || !input) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          show('error', wrap.getAttribute('data-error-invalid'));
          input.focus();
          return;
        }
        btn.disabled = true;
        show('', '');

        var body = JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: wrap.getAttribute('data-source'),
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: wrap.getAttribute('data-list') } } }
          }
        });

        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(wrap.getAttribute('data-company')));
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('revision', '2024-10-15');
        xhr.onload = function () {
          btn.disabled = false;
          if (xhr.status >= 200 && xhr.status < 300) {
            try { window.klaviyo && window.klaviyo.identify && window.klaviyo.identify({ email: email }); } catch (err) {}
            wrap.classList.add('is-done');
            var code = wrap.getAttribute('data-code');
            if (code) {
              msg.innerHTML = '';
              var t = document.createElement('div');
              t.textContent = wrap.getAttribute('data-success-code');
              var c = document.createElement('span');
              c.className = 'pe-lp-optin__code';
              c.textContent = code;
              msg.appendChild(t);
              msg.appendChild(c);
              msg.setAttribute('data-state', 'ok');
            } else {
              show('ok', wrap.getAttribute('data-success'));
            }
          } else {
            show('error', wrap.getAttribute('data-error'));
          }
        };
        xhr.onerror = function () { btn.disabled = false; show('error', wrap.getAttribute('data-error')); };
        xhr.send(body);
      });

      function show(state, text) {
        msg.setAttribute('data-state', state);
        msg.textContent = text || '';
      }
    });
  }

  /* ---------------- native video (page A) ---------------- */
  function initVideoPlayers() {
    document.querySelectorAll('[data-pe-lp-vplayer]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-pe-lp-vplay]');
      if (!video || !btn) return;
      // Native controls come back on first play; hiding them before that keeps iOS from drawing
      // its own play button over the design's one. Without JS the controls simply stay on.
      video.controls = false;
      btn.addEventListener('click', function () {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { wrap.classList.remove('is-playing'); });
      });
      video.addEventListener('play', function () { wrap.classList.add('is-playing'); video.controls = true; });
      video.addEventListener('ended', function () { wrap.classList.remove('is-playing'); });
    });
  }

  /* ---------------- hero video (page A) ---------------- */
  // Muted, looping. Starts only after the page has loaded and while it is on screen; never with
  // reduced motion or data saver (the sound button still starts it then). Pauses off screen.
  function initHeroVideo() {
    document.querySelectorAll('[data-pe-lp-hero-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video[data-pe-lp-ambient]');
      if (!video) return;
      var btn = wrap.querySelector('[data-pe-lp-sound]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      var autoOK = !reduce && !saveData;
      var loaded = false, inView = false, engaged = false;
      video.muted = true;

      function play() {
        video.preload = 'auto';
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      function maybePlay() { if (loaded && inView && (autoOK || engaged)) play(); }

      video.addEventListener('playing', function () { wrap.classList.add('is-playing'); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView) maybePlay(); else if (!video.paused) video.pause();
          });
        }, { threshold: 0.2 }).observe(wrap);
      } else {
        inView = true;
      }

      function onLoaded() { loaded = true; setTimeout(maybePlay, 250); }
      if (document.readyState === 'complete') onLoaded(); else window.addEventListener('load', onLoaded, { once: true });

      if (btn) {
        btn.addEventListener('click', function () {
          engaged = true;
          var turnOn = video.muted;
          video.muted = !turnOn;
          btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
          btn.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
          if (turnOn && video.paused) play();
        });
      }
    });
  }

  function init() {
    initSticky();
    initVideo();
    initVideoPlayers();
    initHeroVideo();
    initOptin();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
